import Arquivo from '../arquivos/Arquivo';
import Tenant from '@/models/tenant/Tenant';
import Paciente from '../pacientes/Pacientes';

export default class ExamesComplementares {
    public id: number;

    public descricao: string;

    public arquivosEmAnexo: Arquivo[] = [];

    public examesComplementaresSomenteComAnexo: boolean;

    public tenantId: number;

    public pacienteId: number;

    public tenant: Tenant;

    public paciente: Paciente;

    constructor() {
      this.id = 0;
      this.descricao = '';
      this.examesComplementaresSomenteComAnexo = false;
      this.tenantId = 0;
      this.pacienteId = 0;
      this.tenant = new Tenant();
      this.paciente = new Paciente();
    }
}
